module.exports = __webpack_public_path__ + "static/media/media.7e5e1b69.jpg";